import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ShopingCartPage.module.css';
import ConnUrls from '../Connections/ConnectURL';
import PlusMinusSelect from '../ForAllComponents/PlusMinusSelect';

import { TheOrderContext } from '../Contexts/TheOrder_Context';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import PopUpClearComp from '../PopUps/PopUpClearComp';
import TimeAndDateSelctionPop from '../PopUps/TimeAndDateSelctionPop';
import { UserContext } from '../Contexts/User_Context';
import LogOrRegPagePop from '../PopUps/LogOrRegPagePop';
import UserAdresses from '../PopUps/UserAdresses';
import { MasterContext } from '../Contexts/Master_Context';
import GetSpecialRemarks from '../PopUps/GetSpecialRemarks';
import MyFunctions from '../Functions/MyFunctions';
import { ArrowCircleLeftOutlined } from '@mui/icons-material';
import FinishedOrder from '../PopUps/FinishedOrder';
import OrederApprovedPop from '../PopUps/OrederApprovedPop';
import PaymentTypePop from '../PopUps/PaymentTypePop';
import utilsOrders from '../Connections/_Utils/utilsOrders';
import PopUpCCTokensCharge from '../PopUps/PopUpCCTokensCharge';
import PopUpCardComIframe from '../PopUps/PopUpCardComIframe';
import utilsUsers from '../Connections/_Utils/utilsUsers';
import utilsCardCom from '../Connections/_Utils/utilsCardCom';
import { SpecialUserContext } from '../Contexts/SpecialUser_Context';
import NoOrdersPop from '../PopUps/NoOrdersPop';
import { CurrentPContext } from '../Contexts/CurrentP_Context';

const ShopingCartPage = (props) => {
    const [master, setMaster] = useContext(MasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const { theOrder, setTheOrder, addToTheOrder, updateTheOrd } = useContext(TheOrderContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [user, setUser, UsspecialUsererEffectFunction] = useContext(UserContext);
    const [specialUser, setSpecialUser] = useContext(SpecialUserContext);
    const [openRemarks, setOpenRemarks] = useState(null); // State to track which remarks section is open
    const [remarks, setRemarks] = useState({}); // State to track remarks input for each item
    const [orderRemarks, setOrderRemarks] = useState();
    const [thePopUp, setThePopUp] = useState();

    const [selectdedDateTime, setSelectdedDateTime] = useState();
    const [theSeleAddress, setTheSeleAddress] = useState();


    const [orderTry, setOrderTry] = useState(false);

    const navigate = useNavigate();
    let popsCount = 0;

    useEffect(() => {
        let tempHomP = { pageName: "ההזמנה שלי" }
        setCurrentPage({ ...tempHomP, pageTYp: "" });
    }, []);

    useEffect(() => {

    }, [theOrder]);

    const updateCountVal = (newVal, index) => {
        let tempOrd = { ...theOrder };
        tempOrd.items[index].mount = newVal;
        setTheOrder(tempOrd);
    };

    const toggleRemarks = (index) => {
        setOpenRemarks(openRemarks === index ? null : index); // Toggle open remarks section
    };

    const setTheTxtRem = (index) => {
        let tempOrd = { ...theOrder };
        tempOrd.items[index].remarks = remarks[index] || ''; // Save remarks for the specific item
        setTheOrder(tempOrd);
        setOpenRemarks(openRemarks === index ? null : index);

    };

    const handleRemarksChange = (index, value) => {
        setRemarks((prevRemarks) => ({
            ...prevRemarks,
            [index]: value,
        }));
    };


    const removeFromCart = (index) => {
        let tempOrd = { ...theOrder };
        tempOrd.items.splice(index, 1)
        updateTheOrd(tempOrd);
    }

    const goOrder = (startOver) => {
        if (!master.blockDeliverys.block) {
            //משתמש לא מחובר עדיין ויש צורך להתחבר או להרשם
            if (!user?.firstName || user?.firstName === "") {
                popsCount++;
                setThePopUp(
                    <PopUpClearComp key={popsCount} BtnTxt={"סגור"}
                        title={""}
                        noLineStart={true}
                        btnFStyle={"fatInBtn"}
                        closePop={() => setThePopUp()}
                        parentCLose={() => setThePopUp()}
                        theInsideComp={
                            <LogOrRegPagePop
                                backFunc={true}
                                closeMeFuc={() => setThePopUp()}
                                parentCLose={() => setThePopUp()}
                                shoTopStrp={(tf) => { }}
                                scrollToTop={(stUp) => { }}
                                connectWithNumber={() => { setThePopUp(); }}
                                heads={["על מנת לבצע הזמנה", "יש צורך להרשם / להתחבר"]}
                            />
                        } />
                )
            }
            else {
                popsCount++;

                if (!startOver && ('dateToDeliver' in theOrder &&
                    ('deliveryAddress' in theOrder || theOrder.OrderType === "Take") &&
                    'items' in theOrder &&
                    'user' in theOrder &&
                    'orderRemarks' in theOrder)) {
                    gobackTo("displayFull", theOrder)
                }
                else {
                    getTimeToDeliver();
                }
            }
        }
        else {
            popsCount++;
            setThePopUp(
                <PopUpClearComp key={popsCount} BtnTxt={"סגור"}
                    title={""}
                    noLineStart={true}
                    btnFStyle={"fatInBtn"}
                    closePop={() => setThePopUp()}
                    parentCLose={() => setThePopUp()}
                    theInsideComp={
                        <NoOrdersPop
                            backFunc={true}
                            closeMeFuc={() => setThePopUp()}
                            parentCLose={() => setThePopUp()}
                            shoTopStrp={(tf) => { }}
                            scrollToTop={(stUp) => { }}
                            connectWithNumber={() => { setThePopUp(); }}
                            heads={["לצערנו לא ניתן כרגע לבצע הזמנות"]}
                        />
                    } />
            )
        }
    }


    const getTimeToDeliver = () => {
        setThePopUp(
            <PopUpClearComp key={popsCount} BtnTxt={"סגור"}
                title={"למתי ההזמנה?"}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => props.parentCLose()}
                inDialogCss={"noPadding"}
                theInsideComp={
                    <TimeAndDateSelctionPop
                        closeMeFuc={() => setThePopUp()}
                        parentCLose={() => props.parentCLose()}
                        continueFunction={(selDateTime) => timeAndDateCont(selDateTime)}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }}
                    />
                } />)
    }

    const timeAndDateCont = (selDateTime) => {
        let tempOrd = { ...theOrder };
        tempOrd.dateToDeliver = selDateTime;

        setTheOrder(tempOrd);

        getDeliveryAddress(tempOrd);

    }


    const getDeliveryAddress = (tempOrd) => {

        popsCount++;
        setThePopUp(
            <PopUpClearComp key={popsCount} BtnTxt={"סגור"}
                cssStyl={"noPadding"}
                title={"כתובת למשלוח"}
                noLineStart={false}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => setThePopUp()}
                inDialogCss={"noPadding"}
                theInsideComp={
                    <UserAdresses inOrder={tempOrd}
                        noHead={true} closeMe={() => setThePopUp()} addId={"SelectAdd"}
                        setTheAddress={(theSeleAddres) => setTheAddress(theSeleAddres, tempOrd)} />
                } />
        )
    }


    const setTheAddress = (theSeleAddres, tempOrd) => {

        let tempO = { ...theOrder };
        if (theSeleAddres) {
            tempO.deliveryAddress = theSeleAddres;
            tempO.OrderType = "Deliver";
            setTheOrder(tempO);
            tempOrd.deliveryAddress = theSeleAddres;
            tempOrd.OrderType = "Deliver";
        }
        else {
            tempO.deliveryAddress = theSeleAddres;
            tempO.OrderType = "Take";
            setTheOrder(tempO);
            tempOrd.deliveryAddress = theSeleAddres;
            tempOrd.OrderType = "Take";
        }

        continueToMoreRequests(tempOrd);
    }

    const continueToMoreRequests = (tempOrd) => {
        popsCount++;

        setThePopUp(

            <PopUpClearComp key={popsCount} BtnTxt={"סגור"}
                cssStyl={"noPadding"}
                title={"כבר מסיימים"}
                noLineStart={false}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => setThePopUp()}
                inDialogCss={"noPadding"}
                theInsideComp={<GetSpecialRemarks
                    inOrder={tempOrd}
                    theFunction={(theRequest) => setSpecialRequests(theRequest,
                        tempOrd.deliveryAddress,
                        tempOrd.dateToDeliver, tempOrd)} />} />
        )
    }

    const setSpecialRequests = (theRequest, theSeleAddres, selDateTime, tempoOrder) => {

        let tempOrd = { ...theOrder };

        tempOrd.dateToDeliver = selDateTime;
        tempOrd.deliveryAddress = theSeleAddres;
        tempOrd.orderRemarks = theRequest;
        tempOrd.OrderType = tempoOrder.OrderType;
        tempOrd.user = specialUser && Object.keys(specialUser).length > 0
            ? { ...specialUser, parentUser: user }
            : user

        setTheOrder(tempOrd);

        showTotal(tempOrd)


    }

    const showTotal = (tempOrd) => {
        popsCount++;

        let ordDetails = {
            theRequest: tempOrd.orderRemarks,
            theSeleAddres: tempOrd.deliveryAddress,
            selDateTime: tempOrd.dateToDeliver,
            OrderType: tempOrd.OrderType,
            user: specialUser && Object.keys(specialUser).length > 0
                ? { ...specialUser, parentUser: user }
                : user
        };

        setThePopUp(

            <PopUpClearComp key={popsCount} BtnTxt={"סגור"}
                cssStyl={"noPadding"}
                title={"אישור ההזמנה"}
                fullPop={true}
                noLineStart={false}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => setThePopUp()}
                inDialogCss={"noPadding noOverFlowScroll"}
                theInsideComp={<FinishedOrder orderDetails={ordDetails} theOrder={tempOrd}
                    gobackTo={(winName) => gobackTo(winName, tempOrd)}
                    theFunction={(backOrder, Approve) => ApprovedOrder_goTopay(backOrder, Approve)} />} />
        )

    }

    const ApprovedOrder_goTopay = (backOrder, Approve) => {

        if (Approve) {

            backOrder.orderPrice = MyFunctions.getOrderPrice(backOrder)
            let delPrc = backOrder.OrderType !== "Take" ? master.cityesToDeliver.filter(itm => itm.cityName === backOrder.deliveryAddress.city)[0] : {
                delivPrice: 0, cityName: "איסוף"
            };
            backOrder.deliveryPrice = parseFloat(delPrc.delivPrice) || 0;
            backOrder.totalPrice = MyFunctions.getOrderTotalPrice(backOrder, delPrc);
            setTheOrder(backOrder);
            setThePopUp(

                <PopUpClearComp key={popsCount} BtnTxt={"סגור"}
                    cssStyl={"noPadding"}
                    title={"אופן תשלום"}
                    noLineStart={false}
                    btnFStyle={"fatInBtn"}
                    closePop={() => setThePopUp()}
                    parentCLose={() => setThePopUp()}
                    inDialogCss={"noPadding"}
                    theInsideComp={< PaymentTypePop
                        closeMeFuc={() => setThePopUp()}
                        theFunction={(ordBakc) => setOrdTypeAndFinish(ordBakc)} theOrd={backOrder} />} />
            )

        }

    }


    const setOrdTypeAndFinish = async (ordBakc) => {
        let serverReplay = await utilsOrders.orderMyFood(ordBakc);

        if (ordBakc.PaymentType === 1) {

            if (serverReplay.msg === "approved") {
                popApprovedOrder(serverReplay)
            }
        }

        else {
            await creditCardCharge(serverReplay.ordr);
        }

    }



    const popApprovedOrder = (serverReplay) => {
        setThePopUp(
            <PopUpClearComp BtnTxt={"סגור"}
                title={""}
                noCloseBtn={true}
                noLineStart={true}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => props.parentCLose()}
                theInsideComp={
                    <OrederApprovedPop
                        backFunc={true}
                        theHelloTxt={"אישור ההזמנה"}
                        closeMeFuc={() => setThePopUp()}
                        parentCLose={() => setThePopUp()()}
                        order={{
                            orderNUM: serverReplay.ordr.orderNUM,
                            paymentStatus: serverReplay.ordr.paymentStatus
                        }}
                        scrollToTop={(stUp) => { }}
                        connectWithNumber={() => { setThePopUp(); }}
                    />
                } />
        )
    }

    const creditCardCharge = async (orderMyFood) => {

        if (!specialUser) {
            let checkForUserTokensCC = await utilsUsers.checkForUserTokensCC(user._id);

            if (checkForUserTokensCC) {
                setThePopUp(

                    <PopUpCCTokensCharge
                        CCtokens={checkForUserTokensCC}
                        removeToken={(tkToremove) => removeToken(tkToremove, orderMyFood)}
                        okClick={(ValueBk) => payByToken(ValueBk, orderMyFood)}
                        btnClick2={() => { newFramCardCom(orderMyFood); setThePopUp() }}
                        handleClose={() => setThePopUp()}
                        cssStyl={"ccTknPopCard centerPop"}
                    />)
            }
            else {
                newFramCardCom(orderMyFood);
            }
        }
        else {
            newFramCardCom(orderMyFood);
        }

    }



    const payByToken = async (theTokeparams, orderMyFood) => {

        let chargeTokback = await utilsCardCom.cardChargeToken({ order: orderMyFood, theTokeparams: theTokeparams });
        if (chargeTokback && chargeTokback !== "Token chargeError" && chargeTokback !== "NO PERMISS") {
            popApprovedOrder(chargeTokback)
        }
        else {
            // setThePopUp(crditTokenProblem()) 
        }

    }



    const removeToken = async (tkToremove, orderMyFood) => {

        let bk = await utilsUsers.removeCCTok(user._id, tkToremove);
        await creditCardCharge(orderMyFood)
    }



    const newFramCardCom = async (orderMyFood) => {
        let cardComBk = await utilsCardCom.goCardCom(orderMyFood);
        if (cardComBk.data != 'ERROR') {
            // if (cardComBk.success) {

            setThePopUp(<PopUpCardComIframe
                cssStyl={""}
                // ContentText={["ביטלת את התשלום?",
                //     "אם לא, משהו כנראה השתבש.",
                //     "ניתן לנסות שוב,",
                //     "ובתור תחלופה, ניתן להמשיך עם ההזמנה",
                //     "ולבצע תשלום במזומן"]}
                ContentText={[]}
                theData={cardComBk.Url}
                BtnTxt={"אשלם במזומן"}
                BtnTxt2={"אנסה שוב"}
                cancelClick={() => setThePopUp()}
                okClick={() => {
                    setThePopUp();
                }}
                btnClick2={() => {
                    setThePopUp();

                }}


            />)

        }
        else {
            // setThePopUp(crditProblem())
        }
    }




    const gobackTo = (winName, ordNew) => {

        if (winName === "theSeleAddres") {
            getDeliveryAddress(ordNew);
        }
        if (winName === "selDateTime") {
            goOrder(true);
        }
        if (winName === "theRequest") {
            continueToMoreRequests(ordNew);
        }
        if (winName === "displayFull") {

            showTotal(ordNew)
        }

    }



    const goBack = () => {
        if (window.history.length > 1) {
            navigate(-1); // Go back in history
        } else {
            navigate(`/Mnu/0`); // Redirect to `/Mnu/0` if no history
        }
    }

    const goToMenu = () => {
        navigate(`/Mnu/0`);
    }
    let delPrc;
    return (
        <div className={`${styles.ShopingCartPage} regularPoint`}>
            <div className={styles.mainHeader}>ההזמנה שלי
                <div className={`${styles.goMenuBtn} pointing bold`} onClick={() => goBack()}>
                    <ArrowCircleLeftOutlined />
                </div>
            </div>
            <div className={styles.tableWrapper}>

                {theOrder.items.map((item, index) => {
                    item = MyFunctions.fixProductPrice(item, theOrder)
                    let totIT = 0;
                    delPrc = master?.cityesToDeliver.filter(itm => itm.cityName === theOrder.deliveryAddress?.city)[0];
                    return (
                        <div key={index} className={styles.productItem}>
                            <div className={styles.tableRow}>
                                {/* Right div */}
                                <div className={styles.tableCell}>

                                    <div className={styles.prodImg}>
                                        <img src={`${ConnUrls.servMediasUrl}${item.prodImageUrl}`} alt={item.prodName || ""} />
                                    </div>
                                </div>
                                {/* Middle div */}
                                <div className={styles.tableCell}>
                                    <div className={`${styles.prodName} bold`}>{item.prodName}</div>

                                    <div className={styles.priceBlock}>
                                        <div className={styles.prodPrice}>₪{item.basePrice}</div>
                                        <div className={styles.PlusMinusSelectWrap}>
                                            <PlusMinusSelect
                                                css={styles.PlusMinusSelect}
                                                plusBtnStyle={styles.plusBtn}
                                                mountNumStyle={styles.mountNum}
                                                minusBtnStyle={styles.minusBtn}
                                                Mount={item.mount || 1} // בדיקת סוג mount
                                                minCount={1}
                                                theVal={(newVal) => updateCountVal(newVal, index)}
                                            />

                                        </div>

                                    </div>
                                    <div className={` flex-1`}>
                                        <div className={" spaceTopBig"}>
                                            <div className={"bold big fullRow"}>
                                                <span className={"fullRow regular"}>כמות: {item.mount || 1}</span>


                                                {item.prodOptions?.map((optionGroup, index) => {
                                                    const selectedOptions = optionGroup.options.filter((opt) => opt.selected);
                                                    totIT += MyFunctions.getSelectedOptionsPrice(selectedOptions);
                                                    return selectedOptions.length > 0 ? (
                                                        <div key={index}>
                                                            <span className={"fullRow regular"}>{optionGroup.optionName}:</span>
                                                            <div>
                                                                {selectedOptions.map((selectedOpt, optIndex) => (
                                                                    <div key={optIndex}>
                                                                        <div className={"fullRow small"}>
                                                                            {selectedOpt.servType}
                                                                            {selectedOpt.mount > 1 ? ` כמות: ${(selectedOpt.mount)}` : ""}
                                                                            {selectedOpt.addToPrice > 0 ? ` (+${(selectedOpt.addToPrice * selectedOpt.mount)})` : ""}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : null;
                                                })}

                                                <div className={"fullRow regular"}>מחיר: ₪{(parseFloat(item.basePrice) + parseFloat(totIT)) * parseInt(item.mount)}</div>

                                            </div>
                                        </div>

                                    </div>
                                    <div className={styles.totalItemPrice}>
                                        <div className={`${styles.removeFromCart} 
                                        bold pointing onRight`} onClick={() => removeFromCart(index)}>
                                            הסר</div>
                                        <div className={`${styles.updateFromCart} 
                                        bold pointing onRight`} onClick={() => navigate(`/prods/${item._id}`)}>
                                            ערוך</div>
                                        <div className={`${styles.totalPriceText} bold`}>
                                            ₪{MyFunctions.getItemTotalPrice(item)}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Remarks section */}

                            <div className={"fullRow"}>
                                <div className={`${styles.remarksB} bold pointing onRight`} onClick={() => toggleRemarks(index)}>
                                    {item.remarks && item.remarks !== "" ? "שינוי הערות" : "הערות למנה"}
                                </div>
                                {
                                    <div className={`margTopBig spaceRight onRight`}>
                                        {item.remarks}
                                    </div>
                                }
                            </div>

                            <div
                                id={`${index}_remarks`}
                                className={`${styles.slideMeUp} ${openRemarks === index ? styles.open : ''}`}
                            >
                                <textarea
                                    id={`${index}_remarksTxt`}
                                    className={styles.remarksTxt}
                                    placeholder={"ספר לנו איך אתה אוהב את האוכל, יש בעיה עם אלרגנים?"}
                                    value={remarks[index] || ''}
                                    onChange={(e) => handleRemarksChange(index, e.target.value)}
                                />
                                <div className={`${styles.ButtonMe} bold pointing`} onClick={() => setTheTxtRem(index)}>
                                    שמור הערה
                                </div>
                            </div>

                            <div className="spaceButtomBig"></div>
                            <div className="seperatorLine"></div>
                            <div className="spaceButtomBig"></div>
                        </div>
                    );
                })}
                <div className={"orderTotalWrap"}>
                    <div className={"fullRow"}>
                        <div className={`${styles.totalHead} bold onRight`}>סכום ההזמנה</div>
                        <div className={`${styles.totalHead} bold onLeft`}>{MyFunctions.getOrderPrice(theOrder)} ₪ </div>
                    </div>


                    <div className={"fullRow"}>
                        {(theOrder.OrderType !== "Take") ?
                            <>
                                {delPrc ?
                                    <div className={`${styles.totalHead} bold onRight`}>משלוח {theOrder.deliveryAddress ? `(${delPrc?.cityName})` : ""}</div>
                                    :
                                    <div className={`${styles.totalHead} bold onRight`}>משלוח </div>
                                }

                                <div className={`${styles.totalHead} bold onLeft`}>
                                    {delPrc ? `${delPrc.delivPrice} ₪` : "בביצוע ההזמנה יש לבחור עיר/איסוף"}
                                </div>
                            </>
                            : <div className={`${styles.totalHead} bold onRight`}>איסוף עצמי </div>
                        }
                    </div>

                    <div className={"fullRow"}>
                        <div className={`${styles.totalHead} bold onRight`}>סה"כ</div>
                        <div className={`${styles.totalHead} bold onLeft`}>{MyFunctions.getOrderTotalPrice(theOrder, delPrc)} ₪ </div>
                    </div>

                    <div className={`${styles.totalHead} bold centerText`}>כל המחירים בשקלים וכוללים מע"מ</div>

                </div>
                <div className={`${styles.goBtn} pointing bold`} onClick={() => goOrder()}>בצע הזמנה</div>
            </div>
            {thePopUp}
        </div>
    );
};

export default ShopingCartPage;
